// import Swiper
import Swiper from 'swiper/bundle'

// Slides
let slider = '.slider'
let swiperOptions = {
    speed: 400,
    centeredSlides: true,
    slideToClickedSlide: true,
    centeredSlidesBounds: true,
    watchOverflow: true,
    slidesPerView: 'auto',
    spaceBetween: 0,

    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 'auto',
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        },
        // when window width is >= 650px
        650: {
            slidesPerView: 2,
            spaceBetween: 20,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        },
        // when window width is >= 800px
        800: {
            slidesPerView: 3,
            spaceBetween: 10,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        },
        // when window width is >= 950px
        950: {
            slidesPerView: 4,
            spaceBetween: 20
        }
    },
}

// Initialise slider
if (swiperOptions) {
    const swiper = new Swiper(slider, swiperOptions)
}
